<template>
  <div class="notifications-item-chat-reaction">
    <div class="notifications-item-chat-reaction__header">
      <div class="notifications-item-chat-reaction__profile">
        <notifications-item-chat-reaction-avatar
          class="notifications-item-chat-reaction__avatar"
          :notification="notification"
        />
        <notifications-item-chat-reaction-profile
          class="notifications-item-chat-reaction__profile"
          hide-notice
          :notification="notification"
        />
      </div>
      <LLTimestamp class="notifications-item-chat-reaction__timestamp" :timestamp="notification.createdAt">
        <template #default="data">
          {{ data.time }}
        </template>
      </LLTimestamp>
    </div>
    <LLFileSlider
      v-if="response.files.length"
      class="notifications-item-chat-reaction__files"
      :owner="owner"
      :files="response.files"
      :z-index="10001"
      small
    ></LLFileSlider>
    <i18n
      path="notifications.item.types.reaction.reacted_message"
      tag="span"
      class="notifications-item-chat-reaction__reacted-message"
    >
      <template #reaction>
        <span
          v-if="!isAnimatedReaction"
          class="notifications-item-chat-reaction__emoji"
          v-html="emojiHtml"
        ></span>
        <span v-else class="notifications-item-chat-reaction__emoji">
          <img class="notifications-item-chat-reaction__emoji" :src="getAnimatedReactionUrl" />
        </span>
      </template>
    </i18n>
    <ForumResponseBodyText
      class="notifications-item-chat-reaction__body"
      :response="response"
      small
      truncate
      lines="2"
    />
  </div>
</template>

<script>
import { NotificationModel } from '@/models/notification'
import ForumResponseBodyText from '@/components/pages/forum/response/body/ForumResponseBodyText.vue'
import LLTimestamp from '@/components/common/LLTimestamp.vue'
import LLFileSlider from '@/components/common/LLFileSlider.vue'
import NotificationsItemChatReactionAvatar from '@/components/modules/notifications/item/reaction/notifications-item-chat-reaction-avatar.vue'
import NotificationsItemChatReactionProfile from '@/components/modules/notifications/item/reaction/notifications-item-chat-reaction-profile.vue'
import emojiToHtml from '@/utils/emojiToHtml'
import { ReactionsEnums } from '@/common/reactionsEnums'
import { ownerFromForumModel } from '@/utils/fileOwner'

export default {
  name: 'NotificationsItemChatReaction',
  components: {
    NotificationsItemChatReactionAvatar,
    NotificationsItemChatReactionProfile,
    LLFileSlider,
    LLTimestamp,
    ForumResponseBodyText
  },
  props: {
    notification: { type: NotificationModel, required: true }
  },
  computed: {
    isAnimatedReaction() {
      return this.reaction.isAnimated
    },
    response() {
      return this.notification.payload.chatResponseReaction.response
    },
    owner() {
      return ownerFromForumModel({
        model: this.response,
        currentUserId: this.$store.getters['user/user']?.id
      })
    },
    getAnimatedReactionUrl() {
      return require(`@/assets/lottie-reactions/preview/${this.animationName}.svg`)
    },
    animationName() {
      return this.reactionsEnums[this.animatedReactionKey]
    },
    reaction() {
      return this.notification.payload.chatResponseReaction.reaction
    },
    animatedReactionKey() {
      return Object.keys(this.reactionsEnums).find(
        (reactionKey) => this.reactionsEnums[reactionKey] === this.reaction?.emoji
      )
    },
    reactionsEnums() {
      return ReactionsEnums
    },
    emojiHtml() {
      return emojiToHtml.span(this.reaction.emoji)
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-item-chat-reaction {
  &__timestamp {
    @apply text-xs flex-shrink-0;
  }
  &__header {
    @apply flex items-center justify-between w-full;
    min-width: 0;
  }
  &__avatar {
    @apply mr-2;
  }
  &__profile {
    @apply flex items-center min-w-0 mr-2;
  }
  &__name {
    @apply min-w-0;
    ::v-deep .ForumResponseProfile__moderator-name {
      @apply text-primary-01;
    }
  }
  &__files {
    @apply mt-2;
  }
  &__body {
    @apply mt-2 text-body-03;
  }
  &__reacted-message {
    @apply text-body-03 mt-2 block;
  }
  &__emoji {
    @apply inline-flex w-5 justify-center items-center h-full;
    ::v-deep & > span {
      @apply flex h-full items-center;
    }
  }
}
</style>
